import React from 'react';
import { isEmpty } from 'lodash';

import List from '@material-ui/core/List';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';

import Virtual from './Virtual';
import ACButton from '../../atoms/ACButton';

import styles from './SetVirtual.module.scss';

export default class SetVirtual extends React.Component {
  renderVirtuals() {
    const { virtuals = [] } = this.props;
    if (!virtuals || isEmpty(virtuals)) return null;
    return (
      <List>
        {virtuals.map((virtual) => (
          <Virtual
            key={virtual.id}
            virtual={virtual}
            onSelectVirtualFunc={this.props.onSelectVirtualFunc}
          />
        ))}
      </List>
    );
  }

  render() {
    const { onCloseFunc, isModifying } = this.props;

    return (
      <Modal open={isModifying} onClose={onCloseFunc}>
        <div className={styles.root}>
          <div>
            <div className={styles.fullWidthColumn}>
              <div className={styles.top}>
                <div>
                  <h3>Add Virtual Experience</h3>
                </div>
                <div>
                  <CloseIcon className={styles.pointerCursor} onClick={onCloseFunc} />
                </div>
              </div>
              <div>
                <ACButton
                  text={'Clear Booking Virtual Experience'}
                  icon={<DeleteOutlined />}
                  iconLast={true}
                  onClickFunc={this.props.onClickClearVirtualExpFunc}
                  color="rgb(255, 118, 95)"
                />
              </div>
              <div className={styles.middle}>
                <div>Available Virtual Experiences</div>
              </div>
            </div>
            {this.renderVirtuals()}
          </div>
        </div>
      </Modal>
    );
  }
}
